import { gql, TypedDocumentNode } from "@apollo/client";

import { GithubIntegration, MutationGithubIntegrationUpdateArgs } from "types/generated";

export type UpdateGitHubIntegrationData = Pick<GithubIntegration, "vcsChecks" | "useGitCheckout">;

type UpdateGitHubIntegrationQueryData = {
  githubIntegrationUpdate: UpdateGitHubIntegrationData;
};

export const UPDATE_GITHUB_INTEGRATION: TypedDocumentNode<
  UpdateGitHubIntegrationQueryData,
  MutationGithubIntegrationUpdateArgs
> = gql`
  mutation UpdateGitHubIntegration($vcsChecks: VCSCheck!, $useGitCheckout: Boolean) {
    githubIntegrationUpdate(vcsChecks: $vcsChecks, useGitCheckout: $useGitCheckout) {
      vcsChecks
    }
  }
`;
